<script>
  import { mapState } from 'pinia'
  import {useAppStore} from "@/store/modules/app";

  export default {
    computed: {
      ...mapState(useAppStore, ['isAppStarted'])
    }
  }
</script>

<template>
  <div class="sheet" :class="{'sheet--active': !isAppStarted}">
    <div class="sheet__inner">
      <div class="sheet__content">
        <div class="sheet__loading">
          <img src="img/logo-full.svg" alt="Logo" />
          <span class="sheet__loading-text">Загрузка&#8230;</span>
        </div>
      </div>
    </div>
  </div>
</template>